import { VOverflowBtn } from 'vuetify/lib'
import commonMixins from './commonMixins'
import { defaultFun } from '../utils'
import { OVERFLOW_BUTTONS } from '../type_name'
export default {
    name: OVERFLOW_BUTTONS,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             _type = 'text',
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        params.type = _type
        return h(VOverflowBtn, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(e) => {
                    this.my_value[key] = e
                    change(e)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup
            }
        })
    
    }
}